var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrossCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 142,
    viewBox: "0 0 142 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_184_50)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 67,
    r: 56,
    fill: "#FF7C04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6231 44.6318C45.4256 44.4342 45.2689 44.1997 45.1619 43.9416C45.055 43.6835 45 43.4068 45 43.1275C45 42.8481 45.055 42.5714 45.1619 42.3133C45.2689 42.0552 45.4256 41.8207 45.6231 41.6231C45.8207 41.4256 46.0552 41.2689 46.3133 41.1619C46.5714 41.055 46.8481 41 47.1275 41C47.4068 41 47.6835 41.055 47.9416 41.1619C48.1997 41.2689 48.4342 41.4256 48.6318 41.6231L70.5 63.4956L92.3682 41.6231C92.5658 41.4256 92.8003 41.2689 93.0584 41.1619C93.3165 41.055 93.5932 41 93.8725 41C94.1519 41 94.4286 41.055 94.6867 41.1619C94.9448 41.2689 95.1793 41.4256 95.3769 41.6231C95.5744 41.8207 95.7311 42.0552 95.8381 42.3133C95.945 42.5714 96 42.8481 96 43.1275C96 43.4068 95.945 43.6835 95.8381 43.9416C95.7311 44.1997 95.5744 44.4342 95.3769 44.6318L73.5044 66.5L95.3769 88.3682C95.5744 88.5658 95.7311 88.8003 95.8381 89.0584C95.945 89.3165 96 89.5932 96 89.8725C96 90.1519 95.945 90.4286 95.8381 90.6867C95.7311 90.9448 95.5744 91.1793 95.3769 91.3769C95.1793 91.5744 94.9448 91.7311 94.6867 91.8381C94.4286 91.945 94.1519 92 93.8725 92C93.5932 92 93.3165 91.945 93.0584 91.8381C92.8003 91.7311 92.5658 91.5744 92.3682 91.3769L70.5 69.5044L48.6318 91.3769C48.4342 91.5744 48.1997 91.7311 47.9416 91.8381C47.6835 91.945 47.4068 92 47.1275 92C46.8481 92 46.5714 91.945 46.3133 91.8381C46.0552 91.7311 45.8207 91.5744 45.6231 91.3769C45.4256 91.1793 45.2689 90.9448 45.1619 90.6867C45.055 90.4286 45 90.1519 45 89.8725C45 89.5932 45.055 89.3165 45.1619 89.0584C45.2689 88.8003 45.4256 88.5658 45.6231 88.3682L67.4956 66.5L45.6231 44.6318Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_184_50",
    x: 0,
    y: 0,
    width: 142,
    height: 142,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_184_50"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_184_50",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossCircle);
export default __webpack_public_path__ + "static/media/cross-circle.b74121c8421742c4a3268ed2350640f6.svg";
export { ForwardRef as ReactComponent };